import { useEffect } from "react";

const FreshdeskWidget = () => {
  useEffect(() => {
    const widgetId = 153000003479;
    const existingScript = document.getElementById("freshdesk-widget-script");
    if (existingScript) return;

    const fwSettingsScript = document.createElement("script");
    fwSettingsScript.type = "text/javascript";
    fwSettingsScript.innerHTML = `
      window.fwSettings = { widget_id: ${widgetId} };
      !function(){if("function"!=typeof window.FreshworksWidget){
        var n=function(){n.q.push(arguments)};
        n.q=[],window.FreshworksWidget=n
      }}();
    `;
    fwSettingsScript.id = "freshdesk-settings-script";
    document.body.appendChild(fwSettingsScript);

    const widgetScript = document.createElement("script");
    widgetScript.type = "text/javascript";
    widgetScript.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
    widgetScript.async = true;
    widgetScript.defer = true;
    widgetScript.id = "freshdesk-widget-script";
    document.body.appendChild(widgetScript);

    const observer = new MutationObserver(() => {
      const launcher = document.getElementById("launcher-frame");
      const lightbox = document.getElementById("lightbox-frame");
      const container = document.getElementById("freshworks-container");

      if (launcher) {
        launcher.style.zIndex = "0";
        launcher.style.position = "fixed";
      }
      if (lightbox) {
        lightbox.style.zIndex = "0";
        lightbox.style.position = "fixed";
      }
      if (container) {
        container.style.zIndex = "0";
        container.style.position = "fixed";
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      const settingsScriptToRemove = document.getElementById("freshdesk-settings-script");
      const widgetScriptToRemove = document.getElementById("freshdesk-widget-script");
      if (settingsScriptToRemove) document.body.removeChild(settingsScriptToRemove);
      if (widgetScriptToRemove) document.body.removeChild(widgetScriptToRemove);
    };
  }, []);

  return null;
};

export default FreshdeskWidget;
